import {
  AfterViewInit,
  Component,
  ContentChildren,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChild
} from '@angular/core';

import {SliderElementDirective} from './slider-element.directive';
import {SliderService} from "./slider.service";

@Component({
  selector: 'app-exc-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss']
})
export class SliderComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() numberOfScrolledElements = 1;
  @ContentChildren(SliderElementDirective) sliderElements: QueryList<SliderElementDirective>;
  @ViewChild('Container') container: ElementRef;
  elementsWidth = 0;
  containerWidth = 0;
  scrollMargin = 0;
  singleElementWidth = 0;
  currentScrollPosition = 0;

  constructor(private sliderService: SliderService) {
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    const that = this;
    window.removeEventListener('resize', that.onResize);
  }

  calculateElements() {
    const {width} = this.sliderElements.first.nativeElement.getBoundingClientRect();
    this.singleElementWidth = width;
    this.elementsWidth = (this.sliderElements.length * (width + 10)) + 80;
    this.numberOfScrolledElements = this.numberOfScrolledElements > this.sliderElements.length ? 1 : this.numberOfScrolledElements;
  }

  calculateContainer() {
    this.containerWidth = this.container.nativeElement.getBoundingClientRect().width;
    this.scrollMargin = this.elementsWidth - this.containerWidth;
  }

  performCalculations() {
    this.calculateElements();
    this.calculateContainer();
    const containerExceeds = this.containerWidth > this.elementsWidth;
    this.sliderService.hideControls.next(containerExceeds);
    this.sliderService.containerExceedsElements.next(containerExceeds);
  }

  onResize() {
    this.performCalculations();
    this.currentScrollPosition = 0;
  }

  registerListener() {
    window.removeEventListener('resize', () => this.onResize());
    window.addEventListener('resize', () => this.onResize());
  }

  ngAfterViewInit() {
    if (this.sliderElements && this.sliderElements.length > 0) {
      setTimeout(() => {
        this.performCalculations();
        this.registerListener();
      }, 0);
    } else {
      this.sliderElements.changes.subscribe(data => {
        setTimeout(() => {
          this.performCalculations();
          this.registerListener();
        }, 0);
      });
    }
  }

  moveSlider(isLeft: boolean) {
    const nextStep = (isLeft ? this.singleElementWidth : -this.singleElementWidth) * this.numberOfScrolledElements;
    const sliderStart = 0;
    const sliderEnd = -this.scrollMargin;
    const nextPosition = this.currentScrollPosition + nextStep;
    if (!isLeft && this.currentScrollPosition - sliderEnd < this.singleElementWidth && this.currentScrollPosition > sliderEnd) {
      this.currentScrollPosition = sliderEnd;
    } else if (isLeft && this.currentScrollPosition * -1 < this.singleElementWidth && this.currentScrollPosition < sliderStart) {
      this.currentScrollPosition = sliderStart;
    } else if (nextPosition >= sliderEnd && nextPosition <= sliderStart) {
      this.currentScrollPosition = nextPosition;
    }
  }

  onControlClick(isLeft: boolean) {
    this.moveSlider(isLeft);
  }
}
